import Swal, { SweetAlertIcon } from "sweetalert2"
import 'animate.css'
const Toast = Swal.mixin({
    toast: true,
    position: 'top-end',
    showConfirmButton: false,
    timer: 3000,
    timerProgressBar: true,
    didOpen: (toast) => {
      toast.addEventListener('mouseenter', Swal.stopTimer)
      toast.addEventListener('mouseleave', Swal.resumeTimer)
    }
  }) 

const ToastConfirmBox=Swal.mixin({
  showDenyButton: true,
  confirmButtonText: 'Yes',
  denyButtonText: `No`,
  backdrop:true,
  allowOutsideClick: false,
  allowEscapeKey: false
})

const confirmBox=async(message:string,title:string="Are you sure?")=>{
  return await ToastConfirmBox.fire({
    title:title,
    text:message
  }).then((result)=>{
    return result.isConfirmed
  })
}
const message=(type:SweetAlertIcon,message:string,isHtml:boolean=false)=>{
    Toast.fire({
        icon: type,
        title:isHtml?undefined:message,
        html:isHtml?message:undefined
      })
} 
const comingSoon=()=>{
  Swal.fire({
		title: 'This feature is coming soon',
		showClass: {
	    	popup: 'animate__animated animate__tada'
	  	},
	  	hideClass: {
	    	popup: 'animate__animated animate__fadeOutUp'
	  	}
  	});
}
const InfoMessage=(message:any)=>{
  Swal.fire({
		title: message,
		showClass: {
	    	popup: 'animate__animated animate__tada'
	  	},
	  	hideClass: {
	    	popup: 'animate__animated animate__fadeOutUp'
	  	}
  	});
}
export {message,confirmBox,comingSoon,InfoMessage}


export const showFileConfirmation = async (fileUpload: any[]): Promise<boolean> => {
  const fileNames = fileUpload
    .map(
      (f) => `
        <li style="
          background:#f8f9fa;
          padding:6px 10px;
          margin:4px 0;
          border-radius:4px;
          border:1px solid #e0e0e0;
          font-weight:500;
          color:#333;
          font-size:13px;
          display:flex;
          align-items:center;
          gap:6px;
        ">
          📄 <span style="overflow:hidden;text-overflow:ellipsis;white-space:nowrap;">${f.file?.name || 'Unnamed file'}</span>
        </li>`
    )
    .join("");

  const hasScroll = fileUpload.length > 3;

  const { isConfirmed } = await Swal.fire({
    title: '<span style="font-size:22px;font-weight:700;color:#2c3e50;">Are you sure?</span>',
    html: `
      <div style="font-size:15px;color:#555;margin-bottom:10px;">
        You are about to submit the following file(s) for processing:
      </div>
      <ul style="
        text-align:left;
        max-height:${hasScroll ? '160px' : 'auto'};
        overflow-y:${hasScroll ? 'auto' : 'visible'};
        list-style:none;
        padding:0;
        margin:0 0 15px 0;
        border:${hasScroll ? '1px solid #e0e0e0' : 'none'};
        border-radius:${hasScroll ? '6px' : '0'};
        padding:${hasScroll ? '8px' : '0'};
      ">
        ${fileNames || "<li>No files selected</li>"}
      </ul>
      <div style="font-size:14px;color:#e74c3c;margin-bottom:15px;padding:10px;background:#fff5f5;border-left:4px solid #e74c3c;border-radius:4px;">
        ⚠️ <strong>Warning:</strong> This action will <strong>permanently delete</strong> the records of the submitted files.
      </div>
    `,
    icon: "warning",
    showCancelButton: true,
    confirmButtonText: "Yes, Submit",
    cancelButtonText: "No, Cancel",
    confirmButtonColor: "#16a085",
    cancelButtonColor: "#e74c3c",
    width: "550px",
    background: "#ffffff",
    backdrop: `
      rgba(0,0,0,0.4)
      left top
      no-repeat
    `,
    allowOutsideClick: false,
  });

  return isConfirmed;
};
// export const showFileConfirmation = async (fileUpload: any[]): Promise<boolean> => {
//   const fileNames = fileUpload
//     .map(
//       (f) => `
//         <li style="
//           background:#f8f9fa;
//           padding:6px 10px;
//           margin:4px 0;
//           border-radius:4px;
//           border:1px solid #e0e0e0;
//           font-weight:500;
//           color:#333;
//           font-size:13px;
//           display:flex;
//           align-items:center;
//           gap:6px;
//         ">
//           📄 <span style="overflow:hidden;text-overflow:ellipsis;white-space:nowrap;">${f.file?.name || 'Unnamed file'}</span>
//         </li>`
//     )
//     .join("");

//   const hasScroll = fileUpload.length > 3;

//   const { isConfirmed } = await Swal.fire({
//     title: '<span style="font-size:22px;font-weight:700;color:#2c3e50;">Are you sure?</span>',
//     html: `
//       <div style="font-size:15px;color:#555;margin-bottom:10px;">
//         You are about to submit the following file(s) for processing:
//       </div>
//       <ul style="
//         text-align:left;
//         max-height:${hasScroll ? '160px' : 'auto'};
//         overflow-y:${hasScroll ? 'auto' : 'visible'};
//         list-style:none;
//         padding:0;
//         margin:0 0 10px 0;
//         border:${hasScroll ? '1px solid #e0e0e0' : 'none'};
//         border-radius:${hasScroll ? '6px' : '0'};
//         padding:${hasScroll ? '8px' : '0'};
//       ">
//         ${fileNames || "<li>No files selected</li>"}
//       </ul>
//       <div style="font-size:15px;margin-top:10px;color:#222;">
//         <strong>Do you really want to proceed?</strong>
//       </div>
//     `,
//     icon: "warning",
//     showCancelButton: true,
//     confirmButtonText: "Yes, Submit",
//     cancelButtonText: "No, Cancel",
//     confirmButtonColor: "#16a085",
//     cancelButtonColor: "#e74c3c",
//     width: "550px",
//     background: "#ffffff",
//     backdrop: `
//       rgba(0,0,0,0.4)
//       left top
//       no-repeat
//     `,
//     allowOutsideClick: false,
//   });

//   return isConfirmed;
// };


// /**
//  * Displays a confirmation popup before submitting files for processing.
//  * @param fileUpload - Array of file objects containing file information
//  * @returns Promise<boolean> - Returns true if user confirms, false if cancelled
//  */
// export const showFileConfirmation = async (fileUpload: any[]): Promise<boolean> => {
//   // Validate input
//   if (!fileUpload || fileUpload.length === 0) {
//     console.warn('No files provided for confirmation');
//     return false;
//   }

//   // Generate file list HTML with improved styling and file size display
//   const fileNames = fileUpload
//     .map((fileObj, index) => {
//       const fileName = fileObj?.file?.name || fileObj?.name || 'Unnamed file';
//       const fileSize = fileObj?.file?.size || fileObj?.size;
//       const formattedSize = fileSize ? formatFileSize(fileSize) : '';
      
//       return `
//         <li style="
//           background: linear-gradient(to right, #f8f9fa, #ffffff);
//           padding: 12px 16px;
//           margin: 8px 0;
//           border-radius: 8px;
//           border: 1px solid #dee2e6;
//           font-weight: 500;
//           color: #2c3e50;
//           display: flex;
//           align-items: center;
//           justify-content: space-between;
//           transition: all 0.2s ease;
//           box-shadow: 0 1px 3px rgba(0,0,0,0.05);
//         ">
//           <span style="display: flex; align-items: center; gap: 10px;">
//             <span style="font-size: 18px;">📄</span>
//             <span style="word-break: break-word; max-width: 400px;">${fileName}</span>
//           </span>
//           ${formattedSize ? `<span style="color: #6c757d; font-size: 13px; font-weight: 400;">${formattedSize}</span>` : ''}
//         </li>
//       `;
//     })
//     .join("");

//   const fileCount = fileUpload.length;
//   const pluralText = fileCount === 1 ? 'file' : 'files';

//   const { isConfirmed } = await Swal.fire({
//     title: `<span style="font-size: 24px; font-weight: 700; color: #2c3e50;">Confirm File Submission</span>`,
//     html: `
//       <div style="text-align: left; padding: 0 10px;">
//         <div style="font-size: 15px; color: #495057; margin-bottom: 16px; line-height: 1.6;">
//           You are about to submit <strong>${fileCount} ${pluralText}</strong> for processing. 
//           Please review the ${pluralText} below before continuing.
//         </div>
        
//         <div style="
//           max-height: 280px; 
//           overflow-y: auto; 
//           margin: 16px 0;
//           padding-right: 8px;
//         ">
//           <ul style="
//             list-style: none; 
//             padding: 0; 
//             margin: 0;
//           ">
//             ${fileNames}
//           </ul>
//         </div>
        
//         <div style="
//           font-size: 15px; 
//           margin-top: 20px; 
//           padding: 14px;
//           background: #fff3cd;
//           border-left: 4px solid #ffc107;
//           border-radius: 6px;
//           color: #856404;
//         ">
//           <strong>⚠️ Important:</strong> Once submitted, this action cannot be undone.
//         </div>
//       </div>
//     `,
//     icon: "warning",
//     iconColor: "#f39c12",
//     showCancelButton: true,
//     confirmButtonText: '<span style="font-weight: 600;">✓ Yes, Submit</span>',
//     cancelButtonText: '<span style="font-weight: 600;">✗ Cancel</span>',
//     confirmButtonColor: "#28a745",
//     cancelButtonColor: "#dc3545",
//     width: "700px",
//     padding: "30px",
//     background: "#ffffff",
//     backdrop: `
//       rgba(44, 62, 80, 0.6)
//       left top
//       no-repeat
//     `,
//     allowOutsideClick: false,
//     allowEscapeKey: true,
//     focusConfirm: false,
//     customClass: {
//       popup: 'file-confirmation-popup',
//       confirmButton: 'file-confirm-btn',
//       cancelButton: 'file-cancel-btn'
//     },
//     showClass: {
//       popup: 'swal2-show',
//       backdrop: 'swal2-backdrop-show',
//       icon: 'swal2-icon-show'
//     },
//     hideClass: {
//       popup: 'swal2-hide',
//       backdrop: 'swal2-backdrop-hide',
//       icon: 'swal2-icon-hide'
//     }
//   });

//   return isConfirmed;
// };

// /**
//  * Helper function to format file size into human-readable format
//  * @param bytes - File size in bytes
//  * @returns Formatted file size string
//  */
// const formatFileSize = (bytes: number): string => {
//   if (bytes === 0) return '0 Bytes';
  
//   const k = 1024;
//   const sizes = ['Bytes', 'KB', 'MB', 'GB'];
//   const i = Math.floor(Math.log(bytes) / Math.log(k));
  
//   return `${parseFloat((bytes / Math.pow(k, i)).toFixed(2))} ${sizes[i]}`;
// };